/**
 * Config file
 * @summary This file should contain all the central configuration variables for the whole project.
 * @howToUse Define the general name of the variable, map that name on the LOCAL, DEV, RC, PROD sections to map the right value from Doppler
 * @return Config JS standard object
 */
const CONFIGS = {
    [import.meta.env.VITE_LOCAL_DOMAIN]: {
        AUTH0_AUDIENCE: import.meta.env.VITE_AUDIENCE_LOCAL,
        API_KEY_INTERNAL: import.meta.env.VITE_API_KEY_INTERNAL_LOCAL,
        SEARCH_SERVICE_URL: import.meta.env.VITE_SEARCH_SERVICE_URL_LOCAL,
        ADMIN_SERVICE_URL: import.meta.env.VITE_ADMIN_SERVICE_URL_DEV,
    },
    [import.meta.env.VITE_DEV_DOMAIN]: {
        AUTH0_AUDIENCE: import.meta.env.VITE_AUDIENCE_DEV,
        API_KEY_INTERNAL: import.meta.env.VITE_API_KEY_INTERNAL_DEV,
        SEARCH_SERVICE_URL: import.meta.env.VITE_SEARCH_SERVICE_URL_DEV,
        ADMIN_SERVICE_URL: import.meta.env.VITE_ADMIN_SERVICE_URL_DEV,
    },
    [import.meta.env.VITE_RC_DOMAIN]: {
        AUTH0_AUDIENCE: import.meta.env.VITE_AUDIENCE_RC,
        API_KEY_INTERNAL: import.meta.env.VITE_API_KEY_INTERNAL_RC,
        SEARCH_SERVICE_URL: import.meta.env.VITE_SEARCH_SERVICE_URL_RC,
        ADMIN_SERVICE_URL: import.meta.env.VITE_ADMIN_SERVICE_URL_RC,
    },
    [import.meta.env.VITE_PROD_DOMAIN]: {
        AUTH0_AUDIENCE: import.meta.env.VITE_AUDIENCE_PROD,
        API_KEY_INTERNAL: import.meta.env.VITE_API_KEY_INTERNAL_PROD,
        SEARCH_SERVICE_URL: import.meta.env.VITE_SEARCH_SERVICE_URL_PROD,
        ADMIN_SERVICE_URL: import.meta.env.VITE_ADMIN_SERVICE_URL_PROD,
    },
};
// /////////////////////////////////
// Generate environment specific config
// /////////////////////////////////
const VITE_CONFIG = CONFIGS[window.location.origin] ?? CONFIGS[import.meta.env.VITE_LOCAL_DOMAIN];
const CONFIG = {
    ...VITE_CONFIG,
};
export default CONFIG;
